import { stringField } from './jsonBody';


export const isTelegramShareCancelled = (error: unknown): boolean =>
  (stringField(error, 'message')?.includes('ERR_CANCELLED') ?? false) ||
  stringField(error, 'type') === 'ERR_CANCELLED';

export const isShareSheetDismissed = (error: unknown): boolean => {
  const name = stringField(error, 'name');
  return name === 'AbortError' || name === 'NotAllowedError';
};
